import { useContext } from 'react'
import { GlobalContext } from 'App'
import { motion } from 'framer-motion';
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties';

import Img1 from 'assets/Home/portfolio/celeb1.avif'
import Img2 from 'assets/Home/portfolio/celeb2.avif'
import Img3 from 'assets/Home/portfolio/celeb3.avif'

const Celeb = ({ data }: any) => {
    const { isTablet } = useContext(GlobalContext)

    return (
        <>
            <section className='pb-24 tablet:pb-8 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    Main Page
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    이달의 셀럽 부터 매칭까지 모든 메뉴를 {!isTablet && <br />}
                    사용자가 한눈에 확인하고 참여할 수 있습니다.
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    이달의 셀럽, 인기셀럽, 셀럽마켓 및 셀럽매칭 등 셀럽하우스를{!isTablet && <br />}
                    아우르는 다양한 서비스를 만나보실 수 있습니다.
                </motion.h4>

                <motion.img
                    src={Img1}
                    alt="Img1"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>

            <section className='pb-24 tablet:pb-8 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    Who is a celeb?
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    다양한 분야의 셀럽들이 만나고{!isTablet && <br />}
                    그들과 어울릴수 있는 매칭을 잡아보세요
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    프로골퍼, 테니스, 방송인, 유튜버 등 다양한 분야에서 활동하는{!isTablet && <br />}
                    셀럽들과 함께 새로운 추억을 만들어 나갈 수 있습니다.
                </motion.h4>

                <motion.img
                    src={Img2}
                    alt="Img2"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>

            <section className='pb-24 tablet:pb-8 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    Matching System
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    셀럽들과 함께 할 수 있는 매칭을 열고{!isTablet && <br />}
                    마음 맞는 셀럽들과 함께 새로우 추억을 만들어 보세요.
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    다양한 활동을 통해 셀럽들과 유대관계를 쌓고 채팅으로 이야기도 나누며,{!isTablet && <br />}
                    팬과 셀럽이 하나되는 양방형 소통의 장에 여러분을 초대합니다.
                </motion.h4>

                <motion.img
                    src={Img3}
                    alt="Img3"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>
        </>
    )
}

export default Celeb
